const version = "4.5.0"
export default version
